import { Box, ButtonGroup, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton } from "@material-ui/core";
import * as React from "react";
import { Datagrid, FunctionField, ListContextProvider, SimpleForm, useNotify } from "react-admin";
import { SectionTitle } from "../../../../../../src/Components/SectionTitle";
import { CustomDateField } from "../../../../../Components/CustomDateField";
import CreatedByField from "../../../../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";

import RemoveCircleOutline from "@material-ui/icons/RemoveCircleOutline";
import { useAppDataProvider } from "../../../../../dataprovider";
import { DownloadButton } from "@airborne/react-admin";
import { UploadFile } from "../../../../../Components/UploadFile";
import keyBy from "lodash/keyBy";

export default function PbhRequestOrderFileUpload(props) {
  const notify = useNotify();
  const dataProvider = useAppDataProvider();
  const [open, setOpen] = React.useState(false);
  const [fileList, setFileList] = React.useState([] as any);

  React.useEffect(() => {
    setOpen(props?.open ?? false);
  }, [props.open]);

  const handleClose = () => {
    setOpen(false);
    props?.handleClose(false);
  };

  const removeButtonClick = async record => {
    await dataProvider
      .deleteFileRelation(record.id, props.source)
      .then(result => {
        notify(`Record Deleted`, "success", false, true);
        fetchData();
      })
      .catch(error => {
        notify(`Error : ${error}`, "error", false, true);
      })
      .finally(() => {});
  };

  const fetchData = () => {
    dataProvider
      .getList(props?.source, {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "createdDate", order: "DESC" },
        filter: {
          pbhRequestOrderId__eq: props?.requestId,
          pbhRequestFileTypeGroupEnum__eq: props?.pbhRequestFileTypeGroup,
          pbhRequestFileTypeEnum__eq: props?.pbhRequestFileType,
        },
      })
      .then(response => {
        setFileList(response?.data);
      });
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth={"lg"} title="Attachments">
      <DialogTitle id="alert-dialog-title">
        <SectionTitle label="ATTACHMENTS" align="Center" color="Primary" />
      </DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <SimpleForm toolbar={false}>
              <UploadFile
                label=""
                multiple={false}
                onHandleFileExecute={() => fetchData()}
                source={props?.source}
                object={{
                  pbhRequestOrderId: props?.requestId,
                  pbhRequestFileTypeGroupEnum: props?.pbhRequestFileTypeGroup,
                  pbhRequestFileTypeEnum: props?.pbhRequestFileType,
                }}
              />
            </SimpleForm>
          </Grid>
          <Divider />
          <Grid item xs={12}>
            {/* <List
            {...props}
            title={false}
            resource={props?.source}
            basePath={props?.source}
            filterDefaultValues={{
              pbhRequestOrderId__eq: props?.requestId,
              pbhRequestFileTypeGroupEnum__eq: props?.pbhRequestFileTypeGroup,
              pbhRequestFileTypeEnum__eq: props?.pbhRequestFileType
            }}
            sort={DefaultCreatedDateSort}
            perPage={DefaultPerPageSize}
            actions={false}
            bulkActionButtons={false}
            exporter={false}
            hasCreate={false}
          > */}
            <ListContextProvider
              value={{
                data: keyBy(fileList, "id"),
                ids: fileList.map(({ id }) => id),
                currentSort: { field: "id", order: "DESC" },
              }}
            >
              <Datagrid optimized>
                <FunctionField
                  render={(record: any) => (
                    <Box style={{ flex: 1, flexDirection: "row" }}>
                      <ButtonGroup variant="text" size="small">
                        <IconButton
                          onClick={e => {
                            e.stopPropagation();
                            removeButtonClick(record);
                          }}
                          color="primary"
                        >
                          <RemoveCircleOutline />
                        </IconButton>
                      </ButtonGroup>
                    </Box>
                  )}
                />
                <FunctionField
                  style={{ fontSize: 12 }}
                  label="Name"
                  render={(record: any) => (
                    <DownloadButton target={`download/${record.objectKey}`} buttonText={record.name} variant="text" />
                  )}
                />
                <CustomDateField source="createdDate" label="CREATED DATE" showTime />
                <CreatedByField label="CREATED BY" link={false} />
              </Datagrid>
            </ListContextProvider>
            {/* </List> */}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
